var _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCropMeloOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agrismart-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("path", {
    d: "m24 12c0 6.6087-5.3913 12-12 12-6.6087 0-12-5.3913-12-12 0-6.6087 5.3913-12 12-12 6.6087 0 12 5.3913 12 12z",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.8696 8.2609c-1.5652 0.26087-2.3478 1.6522-2.6087 3.2174-0.26087 1.8261 0.17391 3.3913 0.86957 4.7826 0.52174 1.0435 1.7391 2.5217 3.1304 2.7826 1.2174 0.17391 1.2174-0.69565 2.3478-0.17391 0.78261 0.43478 1.6522 0 2.1739-0.34782 1.913-1.3043 3.6522-5.0435 2.3478-8.2609-0.17391-0.69565-0.69565-1.2174-1.3043-1.6522-0.69565-0.43478-1.5652-0.43478-2.3478-0.08696-0.78261 0.26087-1.3043 0.6087-2.2609 0.34783-0.78261-0.26087-1.4783-0.69565-2.3478-0.60869z",
    style: {
      fillRule: "evenodd",
      fill: "#009846"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.261 7.913c1.5652-0.17391 2.6087-1.3913 2.6957-2.9565-1.5652 0.17391-2.5217 1.3913-2.6957 2.9565z",
    style: {
      fillRule: "evenodd",
      fill: "#009846"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7826 8.6087c-1.5652 0.26087-2.1739 1.913-2.2609 3.3913 0 0.17391-0.086957 0.69565 0 0.86956 0.086957 0.26087 0.43478 0.34783 0.6087 0.17391 0.26087-0.34783-0.086957-3.4783 2-3.7391 0.6087-0.08696 0.6087-0.86956-0.26087-0.69565z",
    style: {
      fillRule: "evenodd",
      fill: "#fefefe"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropMeloOver);
export default __webpack_public_path__ + "static/media/crop-melo-over.605e1be3a1c0e989a82234839eb6d333.svg";
export { ForwardRef as ReactComponent };